import React from "react";
import { Container, Grid } from "@mui/material";

import { useTranslation } from "react-i18next";

import BackgroundImage from "@components/BackgroundImageCst";
import HeroCst from "@components/HeroCst";
import Breadcrumb from "@components/Breadcrumb";
import CardHomeCst from "@components/CardHomeCst";
import { useMenu, useNavigaionRoutes } from "@hooks/useNavigation";
import { useAuth } from "@context/auth";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useResetFilters } from "@hooks/useFiltersProvider";
import { RolesDigitedEnum } from "../../../../context/auth/types";

const TrainingNeeds: React.FC = () => {
  const { user } = useAuth();
  const { t } = useTranslation(["training-needs-detail-page", "common"]);

  const menuItem = useMenu();
  const navigation = useNavigaionRoutes();

  const trainingNeedSection = [
    "training_needs.campaign.read", // Crea e gestisci
    "training_needs.campaign.complete.read", // Completa Campagna
  ];

  useResetFilters();

  const isPOorBA =
    (user?.roles.includes(RolesDigitedEnum.PRODUCT_OWNER) ||
      user?.roles.includes(RolesDigitedEnum.BUSINESS_ADMIN)) ??
    false;
  const canAccessCampaignCompletion = (): boolean => {
    const isHRManager =
      (user?.roles.includes(RolesDigitedEnum.HR) ||
        user?.roles.includes(RolesDigitedEnum.MANAGER)) ??
      false;
    const isCorporateOne = user?.organization_id == 1;
    // const hasCampaigns = user?.campaigns && user?.campaigns.length > 0;

    if (isPOorBA) {
      return isHRManager && isCorporateOne;
    }
    return isHRManager;
  };

  let trainingNeedsMenu = [];
  if (menuItem.length > 0) {
    trainingNeedsMenu = navigation
      .find((el) => el.to === "training-needs")
      ?.children?.filter((el: any) => {
        if (el.section == "training_needs.campaign.complete.read") {
          return canAccessCampaignCompletion();
        }

        return (
          user?.permissions?.includes(el.section) &&
          trainingNeedSection.includes(el.section) &&
          isPOorBA
        );
      });
  }

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-corporate.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst title={t("hero-title")} description={t("hero-description")} />
        <Grid container spacing={3}>
          {trainingNeedsMenu &&
            trainingNeedsMenu.map((card: any, index: number) => {
              if (
                card.section === "training_needs.campaign.read" &&
                !(
                  user?.permissions?.includes("training_needs.campaign.read") ||
                  user?.roles.includes(RolesDigitedEnum.BUSINESS_ADMIN) ||
                  user?.roles.includes(RolesDigitedEnum.PRODUCT_OWNER)
                )
              ) {
                return null;
              }

              return (
                <Grid key={index} item xs={12} md={6} xl={4}>
                  <CardHomeCst
                    image={card.image}
                    title={card.text}
                    to={card.to}
                    description={card.description}
                    secondaryBtnLabel={card.buttonLabel}
                  />
                </Grid>
              );
            })}
        </Grid>
      </Container>
    </AnimationFadeIn>
  );
};

export default TrainingNeeds;
